import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { ShieldCheck, FileCheck2, Thermometer, ScrollText } from "lucide-react";
import { Seo } from "@/components/common/Seo";
import { PAGES, IMAGES, SEO } from "@/content/site";

const ICONS = [ShieldCheck, FileCheck2, Thermometer, ScrollText];

export default function QualityCompliance() {
  const p = PAGES.quality;
  return (
    <div data-testid="page-quality-compliance">
      <Seo title={SEO.quality.t} description={SEO.quality.d} path="/quality-compliance" />
      <PageHero eyebrow={p.eyebrow} title={p.title} lead={p.lead} image={IMAGES.qualityWorker} />
      <section className="container-x py-16 lg:py-24">
        <div className="grid gap-6 sm:grid-cols-2">
          {p.sections.map((s, idx) => {
            const Icon = ICONS[idx % ICONS.length];
            return (
              <Reveal key={s.heading} delay={idx * 0.06}>
                <div className="h-full rounded-2xl border border-slate-200/80 bg-white p-8 transition-all duration-300 hover:shadow-lg hover:shadow-azeka-navy/5">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-azeka-sage text-azeka-teal">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3 className="mt-5 text-lg font-semibold text-ink-heading">{s.heading}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink-body">{s.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
}
